import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

const BarePlaceholderTableIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper
    height={props.height}
    viewBox='0 0 80 54'
    width={props.width}
    {...props}
  >
    <path d='M0.5 4.5H79V9H0.5V4.5Z' fill='#D6D6D6' />
    <path
      d='M0 2C0 0.895431 0.89543 0 2 0H18.5C19.6046 0 20.5 0.895431 20.5 2V5H0V2Z'
      fill='#D6D6D6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M78 5H2C1.72386 5 1.5 5.22386 1.5 5.5V51.5C1.5 51.7761 1.72386 52 2 52H78C78.2761 52 78.5 51.7761 78.5 51.5V5.5C78.5 5.22386 78.2761 5 78 5ZM2 3.5C0.895431 3.5 0 4.39543 0 5.5V51.5C0 52.6046 0.895429 53.5 2 53.5H78C79.1046 53.5 80 52.6046 80 51.5V5.5C80 4.39543 79.1046 3.5 78 3.5H2Z'
      fill='#D6D6D6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.75 52.5V4H20.75V52.5H19.75ZM39.5 52.5V4H40.5V52.5H39.5ZM59.75 52.5V4H60.75V52.5H59.75Z'
      fill='#D6D6D6'
    />
    <path d='M0.5 9H79.5V9.5H0.5V9Z' fill='#D6D6D6' />
    <path d='M0.5 19H79.5V19.5H0.5V19Z' fill='#D6D6D6' />
    <path d='M0.5 30.5H79.5V31H0.5V30.5Z' fill='#D6D6D6' />
    <path d='M0.5 42H79.5V42.5H0.5V42Z' fill='#D6D6D6' />
  </SvgWrapper>
);
export const PlaceholderTableIcon = memo(BarePlaceholderTableIcon);
